import React from "react";
import ReactECharts from "echarts-for-react";
import { getDonutChartOption } from "../chartConfigs";
import { formatValue } from "../utils";

const DonutCharts = ({ sections, loading }) => {
  return (
    <div className="grid grid-cols-1 gap-4 2xl:grid-cols-3">
      {sections.map((section) => (
        <div
          key={section.title}
          className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
        >
          <div>
            <h2 className="text-lg font-bold text-slate-800">
              {section.title}
            </h2>
            <p className="text-sm font-semibold text-slate-400">
              {section.subtitle}
            </p>
          </div>

          <div className="mt-3">
            <ReactECharts
              option={getDonutChartOption(section)}
              notMerge
              lazyUpdate
              showLoading={loading}
              style={{ height: 230, width: "100%" }}
            />
          </div>

          <div className="mt-3 space-y-2">
            {section.items.slice(0, 6).map((item) => (
              <div
                key={item.name}
                className="flex items-center justify-between gap-3 border-b border-slate-100 pb-1.5 text-sm last:border-b-0"
              >
                <div className="flex min-w-0 items-center gap-2">
                  <span
                    className="h-2.5 w-2.5 rounded-[3px]"
                    style={{ backgroundColor: item.color }}
                  />
                  <span className="truncate text-slate-600 font-semibold">
                    {item.name}
                  </span>
                </div>
                <span className="font-mono text-slate-800 font-semibold">
                  {formatValue(item.value)}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DonutCharts;
